import { useQuery } from '@apollo/client';
import {
  GET_LATEST_NON_DISCRETIONARY_UPDATE_REQUESTS_DETAILS,
  GetLatestNonDiscretionaryUpdateRequestsDetailsQuery,
} from '@fintronners/react-api';
import { getInvestorInformationNonDiscretionaryUpdateRequests } from '@fintronners/react-api/src/utils/formUtils/schemas/pending/investorInformationNonDiscretionary';
import { useMemo } from 'react';

/**
 * This hook is used to fetch a users non discretionary account update requests
 */
const useNonDiscretionaryUpdateRequests = () => {
  const { data, loading, refetch } = useQuery<GetLatestNonDiscretionaryUpdateRequestsDetailsQuery>(
    GET_LATEST_NON_DISCRETIONARY_UPDATE_REQUESTS_DETAILS,
    {
      fetchPolicy: 'no-cache',
    },
  );

  return useMemo(() => {
    const isInitialLoad = loading && !data;

    if (isInitialLoad) {
      return {
        loading: true,
        nonDiscretionaryUpdateRequests: [],
        refetchNonDiscretionaryUpdateRequests: refetch,
      };
    }

    const account = data?.nonDiscretionaryAccountKycs.edges?.[0]?.node;
    const nonDiscretionaryUpdateRequests = getInvestorInformationNonDiscretionaryUpdateRequests(
      account?.updateRequests,
    );

    return {
      loading,
      nonDiscretionaryUpdateRequests,
      refetchNonDiscretionaryUpdateRequests: refetch,
    };
  }, [loading, data, refetch]);
};

export default useNonDiscretionaryUpdateRequests;
